// store/schedulesSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { getSchedules } from "../pages/api/api"

const initialState = {
  schedules: [],
  status: "idle", // status: 'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
}

export const fetchSchedules = createAsyncThunk("schedules/fetchSchedules", async (_, thunkAPI) => {
  try {
    const response = await getSchedules()
    return response
  } catch (error) {
    return thunkAPI.rejectWithValue(error.message)
  }
})

const schedulesSlice = createSlice({
  name: "schedules",
  initialState,
  reducers: {
    setSchedulesState: (state, action) => {
      console.debug("ACT PAY", action.payload)
      state.schedules = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSchedules.pending, (state) => {
        state.status = "loading"
      })
      .addCase(fetchSchedules.fulfilled, (state, action) => {
        state.status = "succeeded"
        // Store schedules and available_slots as-is from the backend
        state.schedules = action.payload
      })
      .addCase(fetchSchedules.rejected, (state, action) => {
        state.status = "failed"
        state.error = action.payload
      })
  },
})

export const { setSchedulesState, updateScedule } = schedulesSlice.actions
export default schedulesSlice.reducer
